import { images } from '@components/assets/images';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import MultiFileInput from '../MultiFileInput';

type Props = {
  onSelectdFilesChanged: (files: File[]) => void;
  initialValue?: File[];
  maxCount?: number;
};

const MultiFileInputContainer = ({
  onSelectdFilesChanged,
  initialValue = [],
  maxCount,
}: Props) => {
  const [files, setFiles] = useState<File[]>(initialValue);

  const inputRef = useRef<HTMLInputElement>(null);

  const onFileSelectClicked = useCallback(() => {
    const input = inputRef?.current;
    if (!input) return;

    input.value = '';
    input.click();
  }, [inputRef]);

  const onFileSelected = useCallback(
    (selected: File[]) => {
      if (maxCount && files.length + selected.length > maxCount) {
        const clone = [...files, ...selected];
        clone.splice(0, files.length + selected.length - maxCount);

        setFiles(clone);
        return;
      }
      setFiles([...files, ...selected]);
    },
    [files],
  );

  const onDeleteClicked = useCallback(
    (idx: number) => {
      const clone = [...files];

      clone.splice(idx, 1);

      setFiles(clone);
    },
    [files],
  );

  useEffect(() => {
    onSelectdFilesChanged(files);
  }, [onSelectdFilesChanged, files]);

  useEffect(() => {
    files.forEach((item, idx) => {
      const fr = new FileReader();

      fr.onload = () => {
        (
          document.getElementById(
            `image-preview-${item.name}`,
          ) as HTMLInputElement
        ).src = fr.result as string;
      };

      item !== null && fr.readAsDataURL(item);
    });
  }, [files]);
  return (
    <MultiFileInput
      inputRef={inputRef}
      files={files}
      onFileSelectClicked={onFileSelectClicked}
      onFileSelected={onFileSelected}
      onDeleteClicked={onDeleteClicked}
    />
  );
};

export default MultiFileInputContainer;
